(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-volleyball/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-volleyball/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_volleyball = svs.themes.sport_volleyball || {};

  svs.themes.sport_volleyball.initStatusStart = function (data) {
    if (svs.themes.sport_volleyball.isLive(data.status.id)) {
      if (data.status.id > 7 && data.status.id < 13) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">SET ".concat(data.status.id - 7, "</div>");
      } 


      if (data.status.id === 14) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      } 


      if (data.status.id === 26) {
        return '<div class="brick match-status brick-active f-condensed align-center">AVBR</div>';
      } 


      if (data.status.id === 27) {
        return '<div class="brick match-status brick-active f-condensed align-center">UPPH</div>';
      }

      return '';
    } else if (svs.themes.sport_volleyball.isEnded(data.status.id)) {
      if (data.status.id === 25) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">INST</div>';
      } 


      if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
    }

    return '';
  };


  svs.themes.sport_volleyball.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);